// import React from 'react';
// import './index.css';
// import App from './App';
// // import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from "react-router-dom";
// import ReactDOM from "react-dom/client"; // ✅ Use createRoot from React 18


// const root = ReactDOM.createRoot(document.getElementById("root")); // ✅ Correct method
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import './index.css';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <HelmetProvider>
    <App />
    </HelmetProvider>
  </BrowserRouter>
  </React.StrictMode>
);